import { defineStore } from "pinia";
import { actions } from "./actions";

export const useGlobalStateStore = defineStore("globalState", {
  state: () => ({
    globalState: {},
    uuid: "",
    exames: {
      EXAME_BETA: {},
      EXAME_ULTRASSOM: {},
    },
    cont_conteudo: {
      beneficios: 0,
      acolhimento: 0,
      conteudos_maternidade: 0,
      conteudos_parentalidade: 0,
      cuidados_com_o_bebe: 0,
      e_books: 0,
      licenca_maternidade: 0,
      licenca_parental_paternidade: 0,
      links_uteis: 0,
      programas_bem_estar: 0,
      reonboarding: 0,
    },
    porcentagemTotal: 0,
    avaliacaoModal: {
      tipoAvaliacao: "",
      porcentagem: 0,
      isOpen: false,
    },
  }),
  getters: {},
  actions,
});
